define('home/views/SettingsProfileView',[
    'jquery',
    'underscore',

    'core/config',

    'home/templates/settingsProfile',
    'home/views/common/BaseSettingsView',
], function (
    $,
    _,

    config,

    settingsProfileTemplate,
    BaseSettingsView
) {
    'use strict';

    var SettingsProfileView = BaseSettingsView.extend({
        template: settingsProfileTemplate,

        events: _.defaults({
            'change select[name=avatar_source]': 'sourceChangeHandler',
        }, BaseSettingsView.prototype.events),

        serializeData: function () {
            var data = BaseSettingsView.prototype.serializeData.call(this, arguments);

            // include the necessary model's attributes that aren't returned in it's
            // toJSON method
            return _.defaults(data, {
                remotes: this.model.get('remotes'),
                avatar_cache: this.model.get('avatar_cache'),
            });
        },

        sourceChangeHandler: function (ev) {
            var $select = $(ev.originalEvent.target);
            var $avatarFileUpload = $('[data-role=avatar-file-upload]');
            var $avatar = this.$el.find('[data-role=avatar-img]');

            var source = $select.val();

            // when user selects 'upload from computer', the value will
            // be 'computer' and we show the file upload input
            if (source === 'computer') {
                $avatarFileUpload.removeClass('hidden');
            } else {
                $avatarFileUpload.addClass('hidden');
                $avatar.attr('src', this.getAvatar(source));
            }
        },

        getAvatar: function (source) {
            switch (source) {
            case 'gravatar':
                return 'https://www.gravatar.com/avatar/' + this.model.get('remotes').gravatar.username;
            case 'twitter':
                // we store http twitter pic urls so we need to ensure the https version is used
                // https://dev.twitter.com/overview/general/user-profile-images-and-banners
                return this.ensureHttpsUrl(this.model.get('remotes').twitter.avatar_url);
            case 'facebook':
                // use graph api directly since profile pictures are always public
                // https://developers.facebook.com/docs/graph-api/reference/v2.2/user/picture
                return 'https://graph.facebook.com/' + this.model.get('remotes').facebook.username.replace('facebook-', '') + '/picture?&height=92&width=92';
            case 'default':
                return config.urls.avatar.generic;
            }
        },

        ensureHttpsUrl: function (url) {
            return url.replace('http:', 'https:');
        },

        getFormData: function () {
            var data = BaseSettingsView.prototype.getFormData.apply(this, arguments);

            // explicity set checkbox fields to true or false so that
            // the model is updated correctly
            data.is_private = Boolean(data.is_private);

            // serializeArray ignores file inputs
            data.avatar_file = this.$form.find('input[name=avatar_file]')[0].files[0] || '';

            return data;
        },
    });

    return SettingsProfileView;
});

